import { PropsWithChildren, createContext, useContext, useState } from "react";

const myHistoryContext = createContext<any>(null);

export function HistoryProvider({ children }:PropsWithChildren) {
  const [history, setHistory] = useState<any[]>([]);

  const push = (location:any) => setHistory([...history, location]);
  const clear = () => setHistory([])

  return (
    <myHistoryContext.Provider value={{ history, push, clear }}>
      {children}
    </myHistoryContext.Provider>
  );
}

export const useHistory = () => useContext(myHistoryContext);